import { render, staticRenderFns } from "./DrawPenguin.vue?vue&type=template&id=5625fac9&"
import script from "./DrawPenguin.vue?vue&type=script&lang=js&"
export * from "./DrawPenguin.vue?vue&type=script&lang=js&"
import style0 from "./DrawPenguin.vue?vue&type=style&index=0&id=5625fac9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports